import React from 'react';
import { useLocation } from 'react-router-dom';
import { VisuallyHidden } from '@economic/gaudi';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
    onClick?: (event: any) => void;
    routeTrigger: string;
}

export const RouteDisclosure = React.forwardRef<HTMLSpanElement, Props>(({ onClick, routeTrigger }, ref) => {
    const location = useLocation();
    const hash = location.hash;
    React.useEffect(() => {
        if (hash === routeTrigger && onClick) {
            //Reakit DialogDisclosure needs an event
            onClick(new Event('click', { bubbles: true }));
        }
    }, [hash]);
    return <VisuallyHidden ref={ref} />;
});
